module.exports = __webpack_public_path__ + "img/logo-jsmslpg.84702086.png";